import styled from "@emotion/styled";
import {ReactComponent as airSvg} from "../../../../images/iconAir.svg";

export const AirSvg = styled(airSvg)`
    background-color: #449DF7;
    padding: 6px;
    overflow: visible;
    border-radius: 50%;
    fill: white;
`;